export const ExternalLink = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0033 3.00349H29.0033V12.0035" stroke="currentColor" stroke-width="2"/>
<path d="M18.7103 13.2925L29.0033 3.00349" stroke="currentColor" stroke-width="2"/>
<path d="M16 5.00001H6C5.44771 5.00001 5 5.44772 5 6.00001V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V16" stroke="currentColor" stroke-width="2"/>
</svg>`;
